import React from 'react';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
    root: {
        display: 'flex',
        zIndex: 200,
    },
    paper: {
        marginRight: theme.spacing(2),
    },
    button: {
        color: 'inherit',
    },
    rightIcon: {
        marginLeft: theme.spacing(),
    },
});

class DropdownMenu extends React.Component {
    state = {
        open: false,
    };

    handleToggle = () => {
        this.setState(state => ({ open: !state.open }));
    };

    handleClose = event => {
        this.setState({ open: false });
    };

    render() {
        const { classes, name, menuItems, disabled = false } = this.props;
        const { open } = this.state;

        return (
            <div className={classes.root}>
                <Button
                    disabled={disabled}
                    ref={node => {
                        this.anchorEl = node;
                    }}
                    onClick={this.handleToggle}
                    className={classes.button}
                >
                    {name}
                    <ArrowDropDown className={classes.rightIcon} />
                </Button>
                <Popper
                    open={open}
                    anchorEl={this.anchorEl}
                    transition
                    style={{ zIndex: 10000 }}
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin:
                                    placement === 'bottom'
                                        ? 'center top'
                                        : 'center bottom',
                            }}
                        >
                            <Paper>
                                <ClickAwayListener
                                    onClickAway={this.handleClose}
                                >
                                    <MenuList>
                                        {menuItems.map(item => {
                                            return (
                                                <MenuItem
                                                    disabled={item.disabled}
                                                    key={item.key}
                                                    onClick={() => {
                                                        item.onClick(
                                                            this.handleClose
                                                        );
                                                    }}
                                                >
                                                    {item.name}
                                                </MenuItem>
                                            );
                                        })}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        );
    }
}

export default withStyles(styles)(DropdownMenu);
